"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFreeShippingThreshold = exports.getCountryCurrency = exports.getCountryCode = exports.getCountryInfo = void 0;
var reselect_1 = require("reselect");
var getCountryInfo = function (state) {
    return state.ejsCountryInfo;
};
exports.getCountryInfo = getCountryInfo;
exports.getCountryCode = (0, reselect_1.createSelector)(exports.getCountryInfo, function (countryInfo) { return countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.countryCode; });
exports.getCountryCurrency = (0, reselect_1.createSelector)(exports.getCountryInfo, function (countryInfo) { return countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.currency; });
exports.getFreeShippingThreshold = (0, reselect_1.createSelector)(exports.getCountryInfo, function (countryInfo) { return countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.freeShippingThreshold; });
